import React from 'react';
import useFormContext from "./useFormEventMltComplete.js"

const HistoryEventMlt = () => {

  const { HistoryComment, handleCommentText, addComments } = useFormContext()

  const content = (

    <>

      <div className="col-md-10 mb-5">
        <div className=" bg-light rounded p-3 mt-3 ">
          <div id="History">

          </div>
          <div className="form-group row mb-2 align-items-center spacingOnSendMessageBtn">
            <div className="col-sm-9 pr-0">
              <input
                type="text"
                readOnly=""
                className="custom-font-lt form-control"
                id="staticEmail"
                placeholder="Leave a comment"
                value={HistoryComment}
                onChange={handleCommentText}
              />
            </div>
            <div className="col-sm-3 pl-0">
              <button type="button" className="buttonrequest btn btn-success ml-2"
                onClick={addComments}
              >
                SEND YOUR MESSAGE{" "}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
  return content
}


export default HistoryEventMlt;